import Headroom from "headroom.js";

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, MAIN NAV will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: "main-nav",

  ui: {
    burger: "[js-burger]"
  },

  events: [
    {
      target: "burger",
      on: "click",
      handle() {
        this.ui.burger.classList.toggle("is-active");
        this.mobileNav.classList.toggle("is-visible");
        document.body.classList.toggle("no-overflow");
      }
    }
  ],

  componentDidMount() {
    const header = document.getElementsByClassName("js-header")[0];
    this.mobileNav = document.getElementsByClassName("js-main-nav")[0];
    this.headroom = new Headroom(header, { offset: 100 });
    this.initHeadroom();

    setTimeout(_ => {
      this.el.classList.add("is-visible");
    }, 700);

    window.addEventListener("orientationchange", this.initHeadroom);
  },

  componentWillUnmount() {
    window.removeEventListener("orientationchange", this.initHeadroom);
    this.headroom.destroy();
  },

  initHeadroom() {
    screen.width >= 768 ? this.headroom.init() : this.headroom.destroy();
  }
};
